export interface SuccessCaseContentEditorQuestionTitleProps {
  title?: string;
}

export const SuccessCaseContentEditorQuestionTitle = ({ title }: SuccessCaseContentEditorQuestionTitleProps) => {
  return title ? <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 text-wrap">{title}</h1> : undefined;
};
